import { useTranslation } from 'react-i18next';
import { cn } from '../lib/utils';

const LANG_OPTIONS = [
  { value: 'English', label: 'EN' },
  { value: 'French', label: 'FR' },
  { value: 'Italian', label: 'IT' },
  { value: 'German', label: 'DE' },
];

export function LanguageSelector({ size = 'md', className }) {
  const { i18n } = useTranslation();
  const current = i18n.language || 'English';

  const handleChange = (e) => {
    const lng = e.target.value;
    if (lng) {
      i18n.changeLanguage(lng);
      // Persist explicitly in case detector config changes
      window.localStorage.setItem('i18nextLng', lng);
    }
  };

  const baseClasses =
    size === 'sm'
      ? 'px-2 py-1 text-[11px]'
      : size === 'lg'
      ? 'px-3 py-1.5 text-sm'
      : 'px-2.5 py-1.5 text-xs';

  return (
    <select
      aria-label="Select language"
      value={current}
      onChange={handleChange}
      className={cn(
        'rounded-lg border border-slate-200 bg-white text-slate-700 font-semibold',
        'hover:border-cyan-400 focus:outline-none focus:ring-2 focus:ring-cyan-400/60 focus:border-cyan-500',
        'transition-colors cursor-pointer',
        baseClasses,
        className
      )}
    >
      <option value="English">EN</option>
      <option value="French">FR</option>
      <option value="Italian">IT</option>
      <option value="German">DE</option>
    </select>
  );
}

